import { Component, NgZone } from '@angular/core';

import { NavController, ModalController, NavParams} from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { ToastController } from 'ionic-angular';
import { NotificationData } from '../../providers/notification-data';

import moment from 'moment';
import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { AlertController } from 'ionic-angular';

@Component({
  selector: 'notification-detail',
  templateUrl: 'notification-detail.html'
})
export class NotificationDetailPage {
  sNormalColor = "primary";
  sCheckedColor = "secondary";

  oSelectedNotification;
  ppstatus;
  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , private alertCtrl: AlertController
            , private notificationData: NotificationData
            ) {
    //let selectedpp = navParams.get('pp');
    
    this.init();
    //this.ueModel.iGrundid = navParams.data.grundid;
    this.oSelectedNotification = navParams.data;
    if(this.notificationData.viewmode == "new"){
      this.notificationData.markasread(this.oSelectedNotification);
    }

    //console.log(this.oSelectedPP);

   }
  
  doRefresh(refresh){
    /*
        Promise.all([
            this.ppData.ppstatus(this.oSelectedNotification.grundid),            
          ]).then(data => {
            //console.log(data);
            this.ppstatus = this.ppData.ppstatusdata;      
            refresh.complete();     
          });    
    */
  }  
   init(){
  

   }




  
}



// WEBPACK FOOTER //
// ./src/pages/notifications/notification-detail.ts